<template>
    <div class="gofixInput gofixTextAreaInput" v-bind:class="{gofixInputHasDesc:desc,gofixInputError : (required && !value && blurInput),gofixInputDisable:disabled}">
        <div class="mainInput">
            <!-- <textarea :value="value"
                      :disabled="disabled"
                      :rows="rows"
                      @change="handleChange"
                      v-on:keyup="handleInput"
                      v-on:blur="blurInput = true"
            v-bind:class="{hasValue:value}"></textarea> -->
             <!-- v-model="htmlForEditor" -->
            <vue-editor
            id="editor"
            :disabled="disabled"
            :rows="rows"
            @change="handleChange"
            :value="value"
            v-bind:class="{hasValue:value}"
            v-on:keyup="handleInput"
            text-change	= "handleInput"
            >
            </vue-editor>
        </div>
        <p class="desc" v-if="desc" v-html="desc"></p>
    </div>
</template>

<script>
    import { VueEditor } from "vue2-editor";

    export default {
        name: "textarea-input",
        props: {
            desc: {
                type: String,
                required: false,
                default: () => null
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            label: {
                type: String,
                required: false,
                default: () => "Label"
            },
            rows: {
                type: Number,
                required: false,
                default: () => 2
            },
            value: {
                default: () => null
            },

            disabled: {
                type: Boolean,
                default: false
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            mode: {
                type: String,
                required: false,
                default: () => "single"
            },
            placeholder: {
                type: String,
                required: false,
                default: () => null
            },
            popoverDirection: {
                type: String,
                required: false,
                default: () => "bottom"
            },
            popoverVisibility: {
                type: String,
                required: false,
                default: () => "focus"
            },

        },

        data() {
            return {
                blurInput:false,
                openPopover:false,
                htmlForEditor:"",
            }
        },
        watch: {


        },
        created(){

        },
        components: {
            VueEditor
        },
        methods: {
            handleInput (e) {
                alert(e.target.value);
                this.$emit("input", e.target.value);
            },
            handleChange (e) {
                this.$emit("change", e.target.value);
            },
            openDatePopover(){
                this.openPopover = true;
            },
            hideDatePopover(){
                this.openPopover = false;
                this.blurInput = true;
            }
        }
    }
</script>
